<section class="card h-100" aria-live="polite">
  <header class="card-header"><div><h3 class="card-title">@if (iconSvg) { <app-dashboard-icon [svg]="iconSvg" class="me-2"></app-dashboard-icon> } {{ title }}</h3><div class="text-secondary small">{{ subtitle }}</div></div></header>
  @if (error) {
    <div class="alert alert-danger m-3" role="alert">{{ error }}</div>
  } @else if (loading) {
    <div class="p-3 text-secondary"><span class="spinner-border spinner-border-sm me-2"></span>Loading posted balances…</div>
  } @else if (!rows.length) {
    <div class="empty py-4"><p class="empty-title">{{ emptyText }}</p></div>
  } @else {
    <div class="table-responsive">
      <table class="table table-vcenter table-sm">
        <thead><tr>@for (column of columns; track column.key) { <th [class.text-end]="column.align === 'end'">{{ column.label }}</th> }</tr></thead>
        <tbody>@for (row of rows; track $index) { <tr>@for (column of columns; track column.key) { <td [class.text-end]="column.align === 'end'">{{ formatValue(row[column.key], column) }}</td> }</tr> }</tbody>
      </table>
    </div>
  }
</section>
